"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNavTabs = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var react_bootstrap_1 = require("react-bootstrap");
exports.StyledNavTabs = (0, styled_components_1.default)(react_bootstrap_1.Nav)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > a.nav-link {\n    ", ";\n    padding: 0 ", ";\n    height: 48px;\n    color: ", ";\n\n    &.active {\n      border-bottom-width: 3px;\n      font-weight: bold;\n    }\n\n    &:not(.active).disabled {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"], ["\n  > a.nav-link {\n    ", ";\n    padding: 0 ", ";\n    height: 48px;\n    color: ", ";\n\n    &.active {\n      border-bottom-width: 3px;\n      font-weight: bold;\n    }\n\n    &:not(.active).disabled {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x3;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.secondary;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Brand.disabled;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.secondary;
});
var templateObject_1;
